import React from "react";

import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
} from "@mui/material";
import { motion } from "framer-motion";
import "../../styles/Subpages.css";
import img1 from "../../assets/bg2.jpg";
import img2 from "../../assets/bg4.jpg";
import img3 from "../../assets/Villa1.jpg";
import img4 from "../../assets/Pccs.jpg";
import img5 from "../../assets/Villa2.jpg";
import img6 from "../../assets/Room.jpg";
import img7 from "../../assets/Lux1.jpg";
import img8 from "../../assets/Load.jpg";
import img9 from "../../assets/Villa3.jpg";
import img10 from "../../assets/Plantsunk.jpg";
import video1 from "../../assets/videos/Resi.mp4";
import video2 from "../../assets/videos/Com.mp4";

const SubPage1 = () => {
  const data = [
    { type: "Civil Work", rate: "₹200 / sq.ft", duration: "4 Months" },
    { type: "Reinforcement", rate: "₹9000 per tonn", duration: "1 week" },
    { type: "Roofing", rate: "₹100 / sq.ft", duration: "1 weeks" },
    {}
  ];

  const media = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

  return (
    <Box className="subpage-container">
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography variant="h4" className="subpage-title">
          Residential Construction Rates
        </Typography>
      </motion.div>

      {/* Construction Table */}
      <Table className="subpage-table">
        <TableHead>
          <TableRow>
            <TableCell><b>Work Type</b></TableCell>
            <TableCell><b>Rate</b></TableCell>
            <TableCell><b>Estimated Duration</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, i) => (
            <TableRow key={i}>
              <TableCell>{row.type}</TableCell>
              <TableCell>{row.rate}</TableCell>
              <TableCell>{row.duration}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* External Link */}
{/* Embedded PDF Viewer */}
<Box className="subpage-pdf">
  <Typography variant="h6" sx={{ mb: 1 }}>
    📄 Labour Contract Quotation
  </Typography>
  <iframe
    src="/files/350_per_sqft.pdf"
    width="100%"
    height="600px"
    style={{ border: "1px solid #ccc", borderRadius: "8px" }}
    title="Essential Home Plan"
  ></iframe>
</Box>


      {/* Media Grid (4 per row on large screens) */}
      <Grid container spacing={4} justifyContent="center" className="media-grid">
        {media.map((src, i) => (
          <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
            <motion.img
              src={src}
              alt={`Construction ${i + 1}`}
              className="grid-image"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Grid>
        ))}

        {[video1, video2].map((src, i) => (
          <Grid item key={`vid-${i}`} xs={12} sm={6} md={4} lg={3}>
            <motion.video
              src={src}
              controls
              className="grid-video"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SubPage1;
